import App from "theme/base/App"
import React from "react"

import "./theme.scss"
import "components/ShoppableImage/ShoppableImage"
import shop from "shop/shop"

// SPALTEN LISTENANSICHT
import orthoFieldConfig from "./ortho-product-list.json"

// SPALTEN PRODUKTDETAILANSICHT
import orthoFieldConfigProductDetails from "./ortho-product-details.json"
import orthoFieldConfigTranslation from "./ortho-field-config-translation.json"

import cmsStore from "stores/cmsStore"
import { setDefaultCurrency } from "components/Price/Price"
import productStore from "stores/productStore"
import EmptyLayout from "layout/EmptyLayout";
import BudgetAccountSelection from "components/Budget/BudgetAccountSelection"
import CurrentCustomerHeader from "components/Header/CurrentCustomerHeader";
import RouteWithLogin from "layout/RouteWithLogin";
import { date } from "notie"

productStore.baseSearchUrl = "data/v2/search" // CONFIG NEW SEARCH URL


setDefaultCurrency( {currencySymbol: "CHF"} )

const getDerivedFieldname = ( value ) => {
	return orthoFieldConfigTranslation[value] || value
}

shop.config.MIN_ORDER_PENALTY_VALUE = 50
shop.config.budgetManager = true
shop.config.disable_handId_redirect = true

const mapCustomFieldData = ( data ) => {

	const configByCategoryId = {}
// DEFAULT CONFIG
	data.push( {
		"id": 2,
		"mapid": "DEFAULT",
		"text": "Brackets",
		"parent": "",
		"": "1",
		"spalte1": "ArtikelNrLAG",
		"spalte2": "Bezeichnung1",
		"spalte3": "Hersteller",
		"spalte4": "Bestell-Menge",
		"spalte5": "Preis"
	}, )

	data.push({
		
			"mapid": "DEFAULT_EXTENDED",
			"Text": "Brackets",
			"parent": "",
			"id": "DEFAULT_EXTENDED",
			"Spalte 1": "ArtikelNrLAG",
			"Spalte 2": "Bezeichnung1",
			"Spalte 3": "Bezeichnung2",
			"Spalte 4": "Z_Produktname",
			"Spalte 5": "Z_Hersteller",
			"Spalte 6": "Z_Brackets_Einzelzahn_Fall",
			"Spalte 7": "Z_Brackets_Vestibualaer_Lingual",
			"Spalte 8": "Z_Brackets_Wirkweise",
			"Spalte 9": "Z_Material",
			"Spalte 10": "Z_Brackets_Herstellung",
			"Spalte 11": "Z_Brackets_Design",
			"Spalte 12": "Z_Brackets_Profil_in_out",
			"Spalte 13": "Z_RX_Presc_in_Grade",
			"Spalte 14": "Z_Slotgroesse",
			"Spalte 15": "Z_Brackets_Haken",
			"Spalte 16": "Z_Zahn_Nummer",
			"Spalte 17": "Z_Brackets_RX_Torque",
			"Spalte 18": "Z_Brackets_Aux_V_Slot",
			"Spalte 19": "Z_Brackets_APC",
			"Spalte 20": "Z_Brackets_Offset",
			"": "Z_Brackets_Werte",
			"Spalte 100021": "Z_Verpackungseinheit_Anzahl",
			"Spalte 100022": "Bestell-Menge",
			"Spalte 100023": "Preis",
			"Spalte 10006": "Z_Boegen_Bogenform",
			"Spalte 10007": "Z_Boegen_Bogendimension",
			"Spalte 10008": "Z_Boegen_Typ",
			"Spalte 10009": "Z_OK_UK",
			"Spalte 100010": "Z_Boegen_Kiefergroesse",
			"Spalte 100011": "Z_Boegen_Machart",
			"Spalte 100012": "Z_Lingual",
			"Spalte 100013": "Z_Boegen_Geeignet_fuer_Retainer",
			"Spalte 100014": "Z_Boegen_Geflochten",
			"Spalte 100015": "Z_Boegen_Spezialitaet",
			"Spalte 100016": "Z_Boegen_Haekchen_Abstand",
			"Spalte 100017": "Z_Boegen_Solo_Packs",
			"Spalte 100018": "Z_Boegen_Zahnfarben"
		  

	})

	data.map( categoryConfig => {
		let columns = []
		columns.push( getDerivedFieldname( categoryConfig["Spalte 1"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 2"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 3"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 4"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 5"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 6"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 7"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 8"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 9"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 10"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 11"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 12"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 13"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 14"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 15"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 16"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 17"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 18"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 19"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 20"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 21"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 22"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 23"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100021"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100022"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100023"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 10006"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 10007"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 10008"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 10009"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100010"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100011"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100012"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100013"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100014"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100015"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100016"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100017"] ) )
		columns.push( getDerivedFieldname( categoryConfig["Spalte 100018"] ) )
		categoryConfig.columns = columns
		configByCategoryId[categoryConfig.mapid] = categoryConfig
	} )

	return configByCategoryId
}

cmsStore.config.orthoFieldConfigByCategory = mapCustomFieldData( orthoFieldConfig )
cmsStore.config.orthoFieldProductDetailConfigByCategory = mapCustomFieldData( orthoFieldConfigProductDetails )
cmsStore.config.hideAddtionalCheckoutMetaForPowerUsers = true

// cmsStore.config.filter_defaults.view = "list"

class AppOrtho extends React.Component {

	componentWillMount() {
		cmsStore.config.filter_defaults = {
			sort: "sort"
		}
		cmsStore.config.standards = {
			sort: "sort"
		}
	}

	render() {
		return <App
			before={<div className="bg-dark ph2 pv2"><CurrentCustomerHeader/></div>}
		>
			<RouteWithLogin layout={EmptyLayout} path={"/login/accounts/:customerId?"} component={BudgetAccountSelection}/>
			<RouteWithLogin layout={EmptyLayout} path={"/account/budgets"} component={BudgetAccountSelection}/>
		</App>
	}
}

export default AppOrtho



// WEBPACK FOOTER //
// ./src/theme/ortho-test/App.js